import {Component, EventEmitter, Injector, OnInit, Output} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';
import {ModalBaseComponent} from '../modal-base-component';
import {ImportFileService} from '../../../shared/services/import-file.service';
import {AlertService} from '../../../shared/services/alert.service';
import {ErrorHandlingService} from '../../../shared/services/error-handling-service';

@Component({
  selector: 'app-import-progress-modal',
  templateUrl: './import-progress-modal.component.html',
  styleUrls: ['./import-progress-modal.component.css']
})
export class ImportProgressModalComponent extends ModalBaseComponent implements OnInit {

  type: string;
  formData: FormData;
  cardStatusResult = {};
  interval: any;
  repeat = 2000;
  done = false;
  status: string;
  filename: string;
  @Output() action = new EventEmitter();

  constructor(inject: Injector, private _bsModalRef: BsModalRef,
              private importFileService: ImportFileService,
              private alertService: AlertService,
              private errorHandlingService: ErrorHandlingService) {
    super(inject);
  }


  ngOnInit() {
    this.importCards();
  }

  public closeModal(): void {
    this._bsModalRef.hide();
  }

  public importCards() {
    this.importFileService.importCards(this.formData).subscribe(x => {
      this.cardStatusResult = x;
      this.filename = x['filename'];

      this.executeCardsImporting();

      this.interval = setInterval(() => {
        this.executeCardsImporting();
      }, this.repeat);
    }, error1 => {
      this.errorHandlingService.errorHandling(error1);
      this.closeModal();
    });
  }

  private executeCardsImporting() {
    this.importFileService.cardImportStatus(this.filename).subscribe(x => {
      if (x['state'] === 'FINISHED' || x['state'] === 'STOPED') {

        this.status = x['state'];
        const value = {
          state: x['state'],
          filename: this.cardStatusResult['filename']
        };
        this.status = x['state'];
        this.stop();
        this.action.emit(value);
        this.done = true;
      }
    }, error1 => {
      this.errorHandlingService.errorHandling(error1);
      this.stop();
      this.done = true;
    });
  }

  private stop() {
    clearInterval(this.interval);
  }

  close(value) {
    this.action.emit(value);
    this._bsModalRef.hide();
  }

  public downloadLogFile(): void {
    this.importFileService.downloadCardImportLogFile(this.filename).subscribe(data => {
      this.downloadFile(data);
    });
  }

  private downloadFile(data: any) {
    const blob = new Blob([data], {type: 'text/csv'});
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = this.filename + '.log';
    link.click();

    window.URL.revokeObjectURL(url);

    // this.closeModal();
  }
}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/modals/import-progress-modal/import-progress-modal.component.ts